import { render, staticRenderFns } from "./TableExtractValidation.vue?vue&type=template&id=1889b99d"
import script from "./TableExtractValidation.vue?vue&type=script&lang=js"
export * from "./TableExtractValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports